import { computed } from '@vue/composition-api';
import { stringLength } from '@tt4b/ttam-utils';
import { ValidationError } from '@tt4b/ttam-hooks';
import { i18n } from './../../../i18n';

export const videoCodeValidator = computed(() => [
  {
    validator: (rule, value, callback) => {
      if (!stringLength(value)) {
        return callback(
          new ValidationError({
            message: i18n.t('module_library_native_video_code_empty'),
            messageI18nKey: 'module_library_native_video_code_empty',
          }),
        );
      }

      return callback();
    },
    trigger: 'custom',
  },
]);

export const fromVideoCodeValidator = computed(() => [
  {
    validator: (rule, value, callback) => {
      if (!stringLength(value)) {
        return callback(
          new ValidationError({
            message: i18n.t('module_library_native_video_original_post_code_empty'),
            messageI18nKey: 'module_library_native_video_original_post_code_empty',
          }),
        );
      }

      return callback();
    },
    trigger: 'custom',
  },
]);
